<div *ngIf="!!claim" class="form-block">

  <kendo-listview [data]="messages$ | async" containerClass="k-d-flex k-flex-col k-flex-nowrap ">

    <ng-template kendoListViewHeaderTemplate>
      <div fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="start center" fxLayout="row">

        <span>{{'claims-center.claimMessages.composeMessage' | translate}}</span>

        <button kendoButton (click)="composePortalMessage()" look="outline">
          <app-sending-channel-icon [sendingChannel]="1" [size]="32"></app-sending-channel-icon>
        </button>

        <button kendoButton (click)="composeSmsMessage()" look="outline">
          <app-sending-channel-icon [sendingChannel]="3" [size]="32"></app-sending-channel-icon>
        </button>

        <button kendoButton (click)="composeEmailMessage()" look="outline">
          <app-sending-channel-icon [sendingChannel]="2" [size]="32"></app-sending-channel-icon>
        </button>

      </div>

    </ng-template>

    <ng-template kendoListViewItemTemplate let-message="dataItem">
      <app-message-item [message]="message" [userDisplayName]="userDisplayName" [applicationPortalTypeId]="1" 
       (threadChangeEvent)="threadChangeEventHandler($event)"></app-message-item>
    </ng-template>

  </kendo-listview>

</div>

<app-loading-panel [isLoading]="!claim "></app-loading-panel>

<div kendoDialogContainer #messageListDialog></div>